import axios from 'axios'
import LoadingRequest from './loading'
axios.defaults.withCredentials = true
let opts = {
    // 是否自动错误提示
    error: true,
    errorConfig: {
        type: 'message'
    },
    // 是否显示加载中状态
    load: true,
    // 默认超时时间
    timeout: 1000 * 60 * 5,
    // 请求方法
    method: 'POST',
    // 当前获取到数据类型
    type: 'json'
}
let alertBol = false

const loading = new LoadingRequest()
export default class Ajax {
    _Vue

    _URL

    _Router

    constructor(Vue, url, router) {
        this._Vue = Vue
        this._URL = url
        this._Router = router
        this.requestBefore()
    }
    /**
     * 发送ajax请求
     * @param {String} url 接口地址
     * @param {Object} params 请求参数
     * @param {Object} options 自定义参数
     *  - error {Boolean} 是否需要自动处理错误信息
     *  - load  {Boolean} 是否需要显示加载中样式
     */
    sendRequest(url, params = {}, options = {

    }) {
        params['u_os'] = 'PC'
        options = Object.assign({ ...opts }, options)
        return new Promise((res, rej) => {
            // console.log(url)
            var ContentTypeName = ''
            if (url == 'Admin/Misc/uploadFile' || url.indexOf('file/upload') > -1) {
                ContentTypeName = 'multipart/form-data'
                params.dataType = 'json'
            } else {
                ContentTypeName = params.dataType == 'json' || options.dataType == 'json' ? 'application/json' : 'application/x-www-form-urlencoded;charset=UTF-8'
            }
            let authorization = {}
            if (localStorage.getItem('userInfo')) {
                const userInfo = JSON.parse(localStorage.getItem('userInfo') || {})
                const token = localStorage.getItem('ccj-token-' + userInfo.name) || ''
                authorization = url.indexOf('api-ycj.nanxinwang.com') > -1 && token ? { 'Authorization': ('Bearer ' + token) } : {}
            }
            let param = {
                url,
                baseURL: (url.indexOf('https://') > -1 || url.indexOf('http://') > -1) ? '' : this._URL,
                method: options.method,
                timeout: options.timeout,
                transformRequest: params.dataType != 'json' && options.dataType != 'json' ? [function (data) {
                    let ret = ''
                    for (let it in data) {
                        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
                    }
                    return ret
                }] : null,
                headers: {
                    ...authorization,
                    isLoading: options.load,
                    // 'Content-Type': params.dataType == 'json' ? 'application/json' : 'application/x-www-form-urlencoded;charset=UTF-8'
                    'Content-Type': ContentTypeName
                },
                responseType: options.type,
            }
            // console.log(param)
            if (options.method && options.method.toLocaleLowerCase() === 'post') {
                param.data = params
            } else {
                param.params = params
            }
            // if (options.load) {
            //     loading.showFullScreenLoading()
            // }
            axios(param).then(data => {
                if (data.status === 200) {
                    // 如果当前的数据类型是流数据，则直接返回数据
                    if (options.type === 'blob') {
                        res({
                            data: data.data
                        })
                        return
                    }
                    // console.log(data)
                    let successCode = 200
                    if (url.indexOf('api-ycj.nanxinwang.com') > -1) {
                        data.data.message = data.data.msg || ''
                        successCode = 0
                    }
                    if (url.indexOf('fu.nanxinwang.com') > -1) {
                        data.data.message = data.data.msg || ''
                        successCode = 0
                    }
                    let {
                        code,
                        data: result,
                        message
                    } = data.data
                    if (code === successCode) {
                        res({
                            status: code,
                            data: result,
                            message
                        })
                        // 需要重新登录
                    } else if (code === 410) {
                        const userInfo = JSON.parse(localStorage.getItem('userInfo') || {})
                        localStorage.removeItem(`product-export-props-${userInfo.name}`)
                        localStorage.removeItem('userInfo');
                        this._Router.replace({
                            path: '/login',
                        })
                    } else if(url.indexOf('Admin/Users/login') > -1 && code === 400){
                        this.errorHandler('message', {
                            message: message,
                        }, rej)
                        setTimeout(() => {
                            location.reload()
                            alertBol = false
                        }, 500)
                    } else if (code === 4002 || code === 4003) {
                        if (!alertBol) {
                            alertBol = true
                            const _this = this
                            this._Vue.prototype.$alert(message, '提示', {
                                confirmButtonText: '知道了',
                                callback: action => {
                                    const userInfo = JSON.parse(localStorage.getItem('userInfo') || {})
                                    localStorage.removeItem(`product-export-props-${userInfo.name}`)
                                    localStorage.removeItem('userInfo');
                                    _this._Router.replace({
                                        path: '/login',
                                    })
                                    setTimeout(() => {
                                        location.reload()
                                        alertBol = false
                                    }, 500)
                                }
                            });
                        }
                    } else {
                        if (code !== 0) {
                            res({
                                status: code,
                                data: result
                            })
                        }
                        if (message.indexOf('session') > -1) {
                            const userInfo = JSON.parse(localStorage.getItem('userInfo') || {})
                            localStorage.removeItem(`product-export-props-${userInfo.name}`)
                            localStorage.removeItem('userInfo');
                            this._Router.replace({
                                path: '/login',
                            })
                        }
                        if (!params.messageHide) {
                            this.errorHandler('message', {
                                message,
                                duration: message === '已禁用' ? 300 : 3000
                            }, rej)
                        }
                    }
                } else {
                    if (!params.messageHide) {
                        this.errorHandler('message', {
                            message: '系统异常，请稍后再试！',
                        }, rej)
                    } 
                }
            }).catch(err => {
                if (!params.messageHide) {
                    if (err.code === 'ECONNABORTED' || err.message.includes('timeout')) {
                        setTimeout(() => {
                            this._Vue.prototype.$message.error('请求超时，请稍后再试！');
                        }, 500)
                    } else if (!window.navigator.onLine) {
                        setTimeout(() => {
                            this._Vue.prototype.$message.error('网络异常，请稍后再试！');
                        }, 500)
                    }else{
                        options.error && this.errorHandler(options.errorConfig.type, {
                            title: '温馨提示',
                            message: '系统异常，请稍后再试！',
                        }, rej)
                    }
                }
                rej({ error: err })
            })
        })
    }

    /**
     * 在请求之前和请求之后做的事
     */
    requestBefore(options) {
        axios.interceptors.request.use(config => {
            // options.load && this._Vue.prototype.$loading({
            //     body: true,
            //     lock: true
            // })
            try {
                if (config.headers.hasOwnProperty('isLoading')) {
                    config.headers.isLoading && loading.showFullScreenLoading()
                    delete config.headers.isLoading
                }
            } catch (error) {
                console.log(error)
            }
            return config
        });
        axios.interceptors.response.use(response => {
            loading.tryHideFullScreenLoading()
            // options.load && this._Vue.prototype.$loading().close();
            return response
        }, err => {
            loading.tryHideFullScreenLoading()
            // options.load && this._Vue.prototype.$loading().close();
            return Promise.reject(err);
        });
    }

    /**
     * 报错处理函数
     * @param {String} type 处理类型
     *  - message   消息提示
     *  - alert     弹框提示
     * @param {Object} options 提示内容配置，同elementUI Message消息提示和MessageBox弹框提示配置
     * @param {Funtion} reject Promise 错误回调
     */
    errorHandler(type, options, reject) {
        switch (type) {
            case 'message':
                console.log('options', options)
                this._Vue.prototype.$message({
                    type: 'error',
                    ...options
                })
                break;
            case 'alert':
                this._Vue.prototype.$message({
                    type: 'error',
                    ...options
                })
                break;
        }
        reject(options)
    }
}



// WEBPACK FOOTER //
// ./src/plugins/ajax/ajax.js